var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0414 8.39868L8.86112 3.5734C8.37921 3.01735 7.49571 3.01982 6.93595 3.58081L3.49832 7.02462C2.47519 8.04899 2.18233 9.5701 2.77422 10.7897C6.31023 18.111 12.2148 24.0238 19.5311 27.5701C20.7495 28.162 22.2694 27.8691 23.2925 26.8447L26.7623 23.3688C27.3245 22.8066 27.3257 21.9181 26.7647 21.4362L21.9209 17.2782C21.4143 16.8432 20.6272 16.9001 20.1193 17.4092L18.4338 19.0971C18.3476 19.1875 18.234 19.2471 18.1105 19.2668C17.9871 19.2864 17.8606 19.265 17.7505 19.2058C14.9955 17.6194 12.7102 15.3311 11.1273 12.574C11.0681 12.4637 11.0466 12.337 11.0662 12.2134C11.0859 12.0897 11.1455 11.9759 11.2361 11.8894L12.9166 10.2077C13.4257 9.69613 13.4813 8.90531 13.0414 8.39745V8.39868Z",
    stroke: "white",
    strokeWidth: 2.47134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ef719377b75e2521e08a320878f91818.svg";
export { ForwardRef as ReactComponent };